import {QueryClient} from "@tanstack/react-query";
import {useDefaultQuery} from "../../../../common/apis/ReactQuery";
import userApiClient from "../../../../common/apis/user/UserApiClient";

export function useUserByLoginQuery(login: string) {
    return useDefaultQuery({
        queryKey: ["users", login],
        queryFn: () => userApiClient.getUserByLogin(login),
    });
}

export function useFindUserGroupsByLoginQuery(login: string) {
    return useDefaultQuery({
        queryKey: ["users", login, "userGroups"],
        queryFn: () => userApiClient.findUserGroupsByLogin(login),
    });
}

export function invalidateFindUserGroupsByLoginQueryCache(login: string, queryClient: QueryClient) {
    queryClient.invalidateQueries({
        queryKey: ["users", login, "userGroups"],
        exact: true,
    });
}
